import { bindActionCreators } from '@reduxjs/toolkit';
import {
  IGenerationProgress,
  generationStateActions,
  selectGenerationState,
  useLazyGetGenerationProgressQuery,
} from '@entities/generation-state';
import { useAppDispatch, useAppSelector } from '@shared/model';
import {
  setGenerationFinishedAt,
  setGenerationIsTimedOut,
  setIsGenerationReportShown,
} from '@pages/invoice-generator/shared/model';
import toast from 'react-hot-toast';
import { setIsGeneratorMenuOpen } from './model/invoiceGeneratorMenuSlice';
import { usePolling } from '@modules/invoice-generator/invoice-generator-menu/hooks/usePolling';

const QueryPolling = () => {
  const { stateId } = useAppSelector(selectGenerationState);
  const [getProgressAsync] = useLazyGetGenerationProgressQuery();

  const dispatch = useAppDispatch();
  const boundedActions = bindActionCreators(generationStateActions, dispatch);

  usePolling<IGenerationProgress>({
    queryKey: ['GET_PROGRESS'],
    fetchData: () => getProgressAsync(stateId).unwrap(),
    onDataReceived: progress => {
      boundedActions.updateProgress(progress);
      boundedActions.setGenerationErrors(progress.errors);
    },
    onComplete: progress => {
      boundedActions.setGenerationErrors(progress.errors);
      boundedActions.resetIsLoading();
      dispatch(setGenerationFinishedAt(new Date().getTime()));
      dispatch(setIsGenerationReportShown(true));
      dispatch(setIsGeneratorMenuOpen(false));
    },
    onTimeout: progress => {
      boundedActions.resetIsLoading();
      boundedActions.setGenerationErrors(progress.errors);
      dispatch(setGenerationFinishedAt(new Date().getTime()));
      dispatch(setIsGenerationReportShown(true));
      dispatch(setIsGeneratorMenuOpen(false));
      dispatch(setGenerationIsTimedOut(true));

      toast.error('Timeout!', {
        duration: 3000,
      });
    },
  });

  return null;
};

export default QueryPolling;
